let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("buZqt")).then(() => parcelRequire('hwDMT'));